import React, { useState } from 'react';
import { formattedDollarValue, TitledDollarInput } from 'venn-components';

export const CapitalLossDeductionCapInput = ({
  taxRate,
  defaultRate,
  title,
  setValue,
  className,
  testId,
  isOptional = false,
}: {
  taxRate: number;
  defaultRate: number;
  title: string;
  setValue: (value: number) => void;
  className?: string;
  testId?: string;
  isOptional?: boolean;
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={className}>
      <TitledDollarInput
        title={title}
        subtitle={isOptional ? '(optional)' : undefined}
        value={taxRate}
        setValue={setValue}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        testId={testId}
        min={0}
        max={100000}
      />
      <span className="text-[12px] text-venn-grey-80">
        {isFocused ? <>Workspace default: {formattedDollarValue(String(defaultRate))}</> : '\u00A0'}
      </span>
    </div>
  );
};
